import { createAsyncThunk } from '@reduxjs/toolkit'

import { calculateTax } from './calculate_tax'
import { createCardToken } from './create_card_token'

export const calculateTotal = createAsyncThunk(
  'payment/calculateTotal',
  async ({ stripe, elements, isStripeDealEnabled }, { dispatch }) => {
    if (!isStripeDealEnabled) await dispatch(createCardToken({ stripe, elements }))

    await dispatch(calculateTax())
  }
)
